import { Component, Input } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-copy-text-button',
  templateUrl: './copy-text-button.component.html',
  styleUrls: ['./copy-text-button.component.scss'],
  standalone: false,
})
export class CopyTextButtonComponent {
  @Input() elementSelector: string;
  @Input() buttonText: string;
  @Input() successMessage: string;

  constructor(
    private snackbarService: SnackbarService,
    private snowplowService: ProductAnalyticsService,
  ) {}

  clickCopy(): void {
    const copyText = document.querySelector('#' + this.elementSelector);
    const range = document.createRange();
    range.selectNode(copyText);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    this.snackbarService.successSnack(this.successMessage);
  }
}
